<template>
  <f7-page
    class="main-loginPage"
    login-screen
    style="background: url('https://www.hispatectrack.com/wp-content/uploads/slider.jpg') no-repeat center center; background-size: cover;"
  >
    <Login
      :has-restore-pass="true"
      :has-remember-me="true"
      :has-need-help="true"
    />
  </f7-page>
</template>

<script>
import Login from '../../components/login/index.vue';

export default {
  name: 'LoginPage',
  components: {
    Login,
  },
  data() {
    return {
      Login,
    };
  },
};
</script>
